module.exports = __webpack_public_path__ + "static/media/generic-logo.c414319d.png";